<template>
    <div class="col-12 d-flex justify-content-center flex-column datatable-pagination">
        <div class="d-flex  justify-content-center">

            <div class="btn btn-link btn-sm" :class="{ disabled: page === 1 }" @click="changePage(1)">
                <i class="fa fa-angle-double-left"></i>
            </div>

            <div class="btn btn-link btn-sm" :class="{ disabled: page === 1 }" @click="changePage(Math.max(1, page - 1))">
                <i class="fa fa-chevron-left"></i>
            </div>

            <div class="btn btn-sm btn-link"
                 v-if="!isContinuous() && page > visibleNumbersRange + 1"
                 @click="changePage(1)">{{ 1 }}</div>

            <div class="btn btn-link text-info btn-sm" v-if="!isContinuous() && getPageRange[0] !== 1 && page - (visibleNumbersRange + 1) > 1" @click="showGoToPage">
                <i class="fa fa-ellipsis-h"></i>
            </div>

            <div class="btn btn-sm"
                 :class="[{ 'btn-dark': page === pi },{ 'btn-link': page !== pi }]"
                 v-for="pi in getPageRange" :key="pi"
                 @click="changePage(pi)">{{ pi }}</div>

            <div class="btn btn-link text-info btn-sm" v-if="!isContinuous() && getPageRange[getPageRange.length - 1] !== pageCount"
                 @click="showGoToPage">
                <i class="fa fa-ellipsis-h"></i>
            </div>

            <div class="btn btn-sm btn-link"
                 v-if="!isContinuous() && lastPage - page > visibleNumbersRange && lastPage - (page + visibleNumbersRange) > 1"
                 @click="changePage(lastPage)">{{ lastPage }}</div>

            <div class="btn btn-link btn-sm" :class="{ disabled: page === pageCount }" @click="changePage(Math.min(pageCount, page + 1))">
                <i class="fa fa-chevron-right"></i>
            </div>

            <div class="btn btn-link btn-sm" :class="{ disabled: page === pageCount }" @click="changePage(pageCount)">
                <i class="fa fa-angle-double-right"></i>
            </div>

        </div>

        <transition name="fade">
            <div class="d-flex justify-content-center mt-3" v-if="goToPageVisible">
                <div>
                    <div class="input-group">
                        <input type="text" class="form-control" :class="status($v.pageToGo)" placeholder="Перейти на страницу" v-model="$v.pageToGo.$model">

                        <div class="input-group-append">
                            <button class="btn btn-secondary" type="button" @click="hideGoToPage">
                                <i class="fa fa-times"></i>
                            </button>
                            <button class="btn btn-primary" type="submit" @click="goToPage">
                                <i class="fa fa-arrow-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

    import { required, numeric } from 'vuelidate/lib/validators'

    export default {
        name: "TablePagination",
        props: {
            page: { type: Number, default: 1},
            pageCount: { type: Number },
            next: { type: String },
            previous: { type: String }
        },
        validations: {
            pageToGo: {
                required,
                numeric,
                inRange(value) {
                    const vm = this;
                    return new Promise((resolve, reject) => {
                       resolve(value >= 1 && value <= vm.pageCount);
                    });
                }
            }
        },
        model: {
            prop: 'page',
            event: 'page-changed'
        },
        data() {
           return {
               visibleNumbersRange: 2,
               goToPageVisible: false,
               pageToGo: undefined,
               goToPageInvalid: false,
               continuousRangeCount: 6
           }
        },
        computed: {
            modelValue: {
                get: function () {
                    return this.page
                },
                set: function (value) {
                    this.$emit('page-changed', value)
                }
            },
            getPageRange() {
                let range = [];
                const isContinuous = this.isContinuous();
                const rangeStart = !isContinuous ? Math.max(1, this.page - this.visibleNumbersRange) : 1;
                const rangeEnd = !isContinuous ? Math.min(this.pageCount, this.page + this.visibleNumbersRange) : Math.min(this.continuousRangeCount, this.pageCount);
                for (let i = rangeStart; i <= rangeEnd; i++) {
                    range.push(i);
                }
                if (!isContinuous && this.lastPage - (this.page + this.visibleNumbersRange) === 1) {
                    range.push(this.lastPage);
                }
                return range;
            },
            lastPage() {
                return this.pageCount
            }
        },
        methods: {
            isContinuous() {
                return this.pageCount <= this.continuousRangeCount
            },
            changePage(p) {
                if (1 <= p && p <= this.pageCount) {
                    this.pageToGo = undefined;
                    this.hideGoToPage();
                    this.modelValue = p;
                }
            },
            showGoToPage() {
                this.goToPageVisible = true;
            },
            hideGoToPage() {
                this.goToPageVisible = false;
            },
            goToPage() {
                if (!this.$v.pageToGo.$error) {
                    this.changePage(this.pageToGo);
                }
            },
            status(validation) {
                return {
                'is-invalid': validation.$error,
              }
            }
        },
    }
</script>

<style scoped lang="scss">

    .datatable-pagination {

    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity .2s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

</style>